import React, {useState, useEffect, useMemo} from 'react';
import {Form, InputNumber, message, Empty,  Select, Space, Tooltip, Modal} from 'antd';
import moment from "moment/moment";
import {CrossTable} from "ali-react-table/pivot";
import { ModeTypeSetObj, ModeType, COL_WIDTH, MIN_WIDTH, getBgColor } from '../const'
import request from "../../../../../request";
import {_APIS} from "../../../../../apis";
import emiter, {
  _EVENTS,
  EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH,
  EVENT_CARRENTAL_VEHICLE_OCCUPYMODAL_OPEN
} from "../../../../../events";
import {allowPermission} from "../../../../../utils/permission";
import {API_VEHICLE_OCCUPY_RELEASE} from "../../../../../hooks/carRental/_";
const { confirm } = Modal;
interface props {
  topTree: any[],
  leftTree: any[],
  dateRange: any,
  store_code: any,
  permission: any,
}
const getCarModelDetail = (params: any) => request.get(_APIS.ORDER_MANAGEMENT.ORDER_LIST.GET_CAR_MODEL_DETAIL, { params });
const MyCrossTable: React.FC<props> = (props) => {
  const { topTree, leftTree, dateRange, store_code, permission } = props
  const [hoverId, setHoverId] = useState<string>('');

  const onRelease = (data: any, row: any) => {
    const dateEnd = moment(data?.occupy_time?.[1] * 1000);
    const dateStart = moment(data?.occupy_time?.[0] * 1000);
    if (moment().isAfter(dateEnd)) {
      message.error('历史占库仅可查看，不可操作！');
      return
    }
    if (data.occupy_type == 1) {
      getCarModelDetail({
        vehicle_model_id: row?.vehicle_id
      }).then((res) => {
        const params = {
          order_code: data.order_id,
          pickup_info: {
            time: data.occupy_time[0] * 1000,
            store_code:store_code
          },
          return_info: {
            time: data.occupy_time[1] * 1000,
          },
          veh_model_info: res.data,
          store_code: store_code,
          veh_info: {veh_code: row?.veh_code},
          sourceType: 'SPOccupyCalendar'
        }
        emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.ARRANGE_CAR, params);
      })
    } else if (data.occupy_type == 0) {
      if (!allowPermission('vehicle_release_stock', permission)) {
        message.error('暂无权限释放占库');
        return
      }
      confirm({
        title: '确认是否释放',
        okText: '确认',
        cancelText: '取消',
        content: '占用时间' + dateStart.format('MM/DD HH:mm') + '~' + dateEnd.format('MM/DD HH:mm'),
        onOk() {
          request({
            url: API_VEHICLE_OCCUPY_RELEASE,
            method: 'POST',
            data: data,
          }).then((res: any) => {
            if (res.data.is_success) {
              message.success('释放成功');
              emiter.emit(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH)
            }
          });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }
  };

  const tableMaxDay = useMemo(() => {
    const lastItem = topTree?.[topTree?.length - 1];
    return lastItem?.data?.end
  }, [topTree])

  const onOccupy = (row: any) => {
    if (!allowPermission('vehicle_occupy_stock', permission)) {
      message.error('暂无占库权限');
      return
    }
    const params =  {
      ...row,
      store_code: store_code,
      veh_id: row.vehicle_id,
      supplier_code: row.supplier_code,
      encrypt_veh_plate: row.encrypt_veh_plate,
      veh_code: row.veh_code
    }
    emiter.emit(EVENT_CARRENTAL_VEHICLE_OCCUPYMODAL_OPEN, params);
  };
  if (!topTree?.length || !leftTree.length) {
    return <Empty style={{marginTop: '50px'}}/>
  }
  return (
    <CrossTable
      useVirtual={{
        vertical: true,
        horizontal: false,
      }}
      isStickyHeader={false}
      topTree={topTree}
      leftMetaColumns={[
        {
          name: `车型（${leftTree.length}）`,
          width: 160,
        },
        {
          name: `车牌号(${leftTree.reduce((pre, cur) => {
            return pre + (cur?.children?.length || 0)
          }, 0)})`,
          width: 100,
        },
      ]}
      leftTree={leftTree}
      render={(value, leftNode: any, topNode: any) => {
        return (leftNode?.data?.occupy_list || []).map((item: any) => {
          const occupyStartOrigin = moment(item.occupy_time[0]* 1000)
          const occupyEndOrigin = moment(item.occupy_time[1]* 1000)
          let maxDate = moment(dateRange.end_date).endOf('day');
          maxDate = moment(tableMaxDay || maxDate);
          const occupyStart = moment(item.occupy_time[0]* 1000)?.isBefore(dateRange.start_date) && moment(item.occupy_time[1]* 1000)?.isAfter(dateRange.start_date) ? moment(dateRange.start_date) : moment(item.occupy_time[0]* 1000);
          const occupyEnd = moment(item.occupy_time[1] * 1000) > maxDate ? maxDate.endOf('day') : moment(item.occupy_time[1] * 1000)
          const curCelStart = moment(topNode?.data?.start)
          const curCelEnd = moment(topNode?.data?.end)
          if (occupyStart >= curCelStart && occupyStart <= curCelEnd) {
            const leftSecond = occupyStart.diff(curCelStart,"minutes")
            const allSecond = occupyEnd.diff(occupyStart,"minutes")
            let width = 0
            let left = 0
            if (topNode?.data?.modeType) {
              const obj = ModeTypeSetObj[topNode?.data?.modeType]
              width = (allSecond / obj.timePeriod) * COL_WIDTH;
              left =  (leftSecond / obj.timePeriod) * COL_WIDTH;
            }
            const occupy_type = item?.occupy_type
            return <Tooltip
              placement="right"
              title={
                occupy_type === 1 ?
                  <>
                    订单占库
                    <div>开始时间{`${occupyStartOrigin.format('YYYY-MM-DD HH:mm:ss')}`}</div>
                    <div>结束时间{`${occupyEndOrigin.format('YYYY-MM-DD HH:mm:ss')}`}</div>
                  </>
                  :
                  <>
                    其他占库
                    <div>开始时间{`${occupyStartOrigin.format('YYYY-MM-DD HH:mm:ss')}`}</div>
                    <div>结束时间{`${occupyEndOrigin.format('YYYY-MM-DD HH:mm:ss')}`}</div>
                  </>
              }>
              <div
                data-occupy={true}
                onClick={() => onRelease(item, leftNode?.data)}
                onMouseEnter={() => setHoverId(`${item.veh_stock_code}-${occupyStart}`)}
                onMouseLeave={() => setHoverId('')}
                style={{
                  backgroundColor: getBgColor(occupy_type, hoverId === `${item.veh_stock_code}-${occupyStart}`),
                  position: 'absolute',
                  zIndex: 1,
                  top: 0,
                  left: left,
                  height: '100%',
                  width: width,
                  borderRadius: 4,
                  fontSize: 14,
                  minWidth: MIN_WIDTH,
                  color: "#fff",
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                { hoverId === `${item.veh_stock_code}-${occupyStart}` ? '修改' : null }
              </div>
            </Tooltip>
          } else {
            return null
          }
        })
      }}
      getCellProps={(value: any, leftNode: any, topNode: any, leftDepth: any, topDepth: any) => {
        return {
          onClick: (e) => {
            if ((e?.target as any)?.dataset?.occupy) {
              return
            }
            onOccupy(leftNode?.data)
          }
        }
      }}
    />
  )
}

export default React.memo(MyCrossTable)
